import { createContext, use } from 'react'

/**
 * Context for sharing table metadata with descendant components.
 *
 * This enables field components to register their popovers with the
 * global table editing store for real-time update isolation.
 */
export interface TableContextValue {
  /** Unique identifier for this table instance */
  tableId: string
}

export const TableContext = createContext<TableContextValue | null>(null)

/**
 * Hook to access the table context.
 * Returns null if used outside a table (e.g., in a standalone field).
 */
export function useTableContext(): TableContextValue | null {
  return use(TableContext)
}
